import React from 'react';
import { RegistrationSteps, Typography } from '@decub8/ui';

const OnboardingHeader: React.FC<{ current_step: number }> = ({
    current_step,
}) => {
    return (
        <div className="max-w-[580px] mx-auto my-[60px]">
            <Typography size="4xl" className="text-center mb-5">
                Get your free allocation!
            </Typography>
            <Typography className="text-center" variant="secondary">
                3 simple steps to claim your Free Base tier and 5,000 investor
                power for IDO and Learn to Earn event participation.
            </Typography>
            <RegistrationSteps
                current_step={current_step}
                className="mt-[60px]"
            />
        </div>
    );
};

export default OnboardingHeader;
